import React, { Component } from "react";
import { connect } from "react-redux";
import { withRouter } from "react-router-dom";
import Config from "../../../Config";

import "./mrtt_client_screen.css";
import AppLoadingDialog from "../../dialog/app_loading_dialog";
import GeneralBloc from "../../../bloc/general_bloc";

class ReviewSuccess extends Component {
    constructor(props) {
        super(props);
        this.state = {
            client: Config.context,
            userDataHeader: null,
            userSettings: {},
            confirmSignature: false,
            signatureContent: null,
            cancelModalOpen: false,
        };
        this.sigpad = {}
    }

    componentDidMount() {
    }

    componentWillUnmount() {
        this.removeClientToken();
    }

    async removeClientToken(){
        await sessionStorage.removeItem('dataClient');
    }

    loadingContent() {
        return (
            <div style={{ height: "100%"}}>
                <AppLoadingDialog isLoading={this.state.loading} />
            </div>
        );
    }

    render() {
        return (
            <div className="client_container" style={{ height: '100%' }}>
                <div className="mobile_container d-fkex justify-content-center" style={{ height: window.innerHeight, overflowY: 'scroll' }}>
                    <div className="client_header">
                        Success
                    </div>
                    <div className="d-flex justify-content-center p-4 row w-100 m-0">
                        <img
                            src={
                                GeneralBloc.getAssetsContextPath() +
                                `/assets/icons/Success.png`
                            }
                            alt="Documents"
                            className=""
                            style={{ width: 175, height: 154 }}
                        />
                        <div className="mt-4">
                            <div className="client_instruction_header">
                                Submission Successful
                            </div>
                            <div className="client_instruction_text mt-2">
                                Your sales representative will receive the proposal, and the signature declaration form with your signature  to proceed with the final submission
                            </div>

                        </div>
                    </div>
                </div>
            </div>
        );
    }
}

const mapStateToProps = (state) => ({
});

export default withRouter(connect(mapStateToProps)(ReviewSuccess));
